import { api } from '@bilibili-maoer/web-utils'

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const WebApi = createApi({
  reducerPath: 'WebApi',
  // TODO: 接入基础的请求处理逻辑
  baseQuery: fetchBaseQuery({ baseUrl: api.MISSEVAN_API_PREFIX_URL }),
  endpoints: () => ({}),
})
